import { YStack, XStack, Text, Circle, Button, SizableText } from "tamagui";
import { AnimNum } from "@screen/Home/pages/HomePage/components/AnimNum"; // 之前拆好的組件
import { colors } from "@styles/colors";
import { useHazePage, v2 } from "@screen/Home/pages/GasShop/skin";
import { RiEyeLine, RiEyeOffLine } from "react-icons/ri";
import { useState } from "react";
import { TopUpActionCard } from "./TopUpActionCard";

interface WalletHeaderProps {
  balance: number;
}

export const WalletBalanceHeader = ({ balance }: WalletHeaderProps) => {
  // 淡霧頁首：餘額是這頁的主角，白字在淡底上完全讀不到 → 深藍
  const haze = useHazePage();
  const [hideBalance, setHideBalance] = useState(false);
  return (
    <>
      <XStack ai="center" gap="$2">
        <Text color={haze ? v2.hazeSub : "rgba(255,255,255,0.75)"} fow="500" fontSize={13}>
          儲值餘額
        </Text>
        <Button
          size="$1"
          circular
          bg="transparent"
          icon={hideBalance ? <RiEyeOffLine size={14} /> : <RiEyeLine size={14} />}
          color={haze ? v2.hazeSub : "white"}
          o={0.7}
          onPress={() => setHideBalance(!hideBalance)}
        />
      </XStack>

      {hideBalance ? (
        <SizableText color={haze ? v2.hazeInk : "white"} fow="800" size="$10" h={58} ai="center">
          ••••••
        </SizableText>
      ) : (
        <AnimNum value={balance} color={haze ? v2.hazeInk : "white"} size={44} unit="NT$" />
      )}

      {/* 優惠標籤組 */}
      <XStack mt="$2">
        <XStack
          backgroundColor={haze ? "#fff" : "rgba(255,255,255,0.18)"}
          borderWidth={haze ? 1 : 0}
          borderColor={haze ? v2.cardBorder : "transparent"}
          borderRadius={20}
          paddingHorizontal={8}
          paddingVertical={3}
          alignItems="center"
          gap={4}>
          <Circle size={6} backgroundColor={colors.green} />
          <Text color={haze ? v2.body : "white"} fontSize={12} fontWeight="500">
            儲值加贈 5%
          </Text>
        </XStack>
      </XStack>
      <TopUpActionCard />
    </>
  );
};
